import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../../i18n/language.service';

@Component({
  selector: 'app-about-night',
  standalone: false,
  templateUrl: './about-night.component.html',
  styleUrls: ['./about-night.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutNightComponent {
  constructor(public language: LanguageService) {}
}
